var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './SpinnerButton.css';
import { CaretForwardOutline } from 'react-ionicons';
export function loadingSpinner(props) {
    return (_jsx("div", __assign({ className: "spinner ".concat(props === null || props === void 0 ? void 0 : props.class) }, { children: "\u00A0" })));
}
export function SpinnerButton(props) {
    var type = props.type, caption = props.caption, isLoading = props.isLoading, isDisabled = props.isDisabled, clickHandler = props.clickHandler, secondary = props.secondary;
    return (_jsx("button", __assign({ className: secondary ? 'btn btn--invert btn--size-primary' : 'btn btn--default btn--size-primary', type: type !== null && type !== void 0 ? type : 'submit', disabled: isLoading || isDisabled, onClick: clickHandler }, { children: isLoading ? loadingSpinner()
            : _jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "btn__label" }, { children: caption })), _jsx("div", __assign({ className: "icon icon--size-regular lazyloaded" }, { children: _jsx(CaretForwardOutline, { color: "currentColor", height: "100%", width: "100%" }) }))] }) })));
}
